import { useParamsSearch } from '@anytag/shared-hooks';
import { MarketplaceCommissionsSearchSchemaType } from '../schemaTypes';

export const useMarketplaceCommissionsFilter = () => useParamsSearch<MarketplaceCommissionsSearchSchemaType>();
